import React, { useEffect } from 'react';
import Header from'../Component/Header'
import { Link } from 'react-router-dom';
const Uniform = () => { 
    useEffect(() => {
        document.title = ' Uniform - Sacread Heart Kharagpur';  
    }, []); 
  return (
     <>
     <Header/>
       <div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                  <li>Academic</li>
                 <li>Uniform</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1>Uniform</h1>
                    </div>
                </div>
                <div className="row">
                     <div className="col-12">
                         <ul className="list">
                         <li> The School uniform is important and students should come to the school wearing a neat and tidy uniform Untidiness in dress and slovenliness in behaviour damages the image of the student and the school. </li> 
                         <li> Any student who does not wear the correct uniform may be refused entry to the class. </li> 
                         <li> School Uniform is to be bought from the School only. </li>
                         </ul>
                    </div>
                </div>
                 
            </div>
        </div>
     </>
  )
}

export default Uniform

